module.exports = __webpack_public_path__ + "img/w2.778d1973.webp";